import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import { domainName } from "../../../utility/index";
import moment from 'moment';

export default {
    name: "FaultManagement",
    components: { tree, iTable, IPagination },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            formInline: {
                selectCarType: '',
                selectCarValue: '',
                terminalId: '',
                eventCode: '',
                eventMessage: '',
                ReportingTime: []
            },
            optionsInput: [{
                value: '0',
                label: this.$t('common.all')
            }, {
                value: '1',
                label: this.$t('common.carId')
            }, {
                value: '2',
                label: this.$t('common.plateNum')
            }, {
                value: '3',
                label: this.$t('common.customNum')
            },
            {
                value: '4',
                label: this.$t('common.manufactureNum')
            }],
            alarmTypeList: [
            ],
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                    width: '200'
                },
                {
                    prop: "manufactureNum",
                    label: this.$t('common.manufactureNum'),
                    align: "center",
                    width: "150px"
                },
                {
                    prop: "customNum",
                    label: this.$t('common.customNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "plateNum",
                    label: this.$t('common.plateNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "terminalId",
                    label: this.$t('common.terminalId'),
                    align: "center",
                    width: '260'
                },
                {
                    prop: "orgName",
                    label: this.$t('common.orgName'),
                    align: "center",
                    width: '200'
                },
                {
                    prop: "eventMessage",
                    label: this.$t('SafeManagement.eventMessage'),
                    align: "center",
                    width: '200'
                },
                {
                    prop: "eventValue",
                    label: this.$t('SafeManagement.eventValue'),
                    align: "center",
                    width: '200'
                },
                {
                    prop: "startTime",
                    label: this.$t('SafeManagement.startTime'),
                    align: "center",
                    width: '200'
                },
                {
                    prop: "endTime",
                    label: this.$t('SafeManagement.endTime'),
                    align: "center",
                    width: '200'
                },
            ],
            dialogFormVisible: false,
            activeName: 'first',
            operates: {
                width: 100,
                fixed: "right",
                list: [
                ],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
        }
    },
    created() {
        this.getDate()
        this.getFault()
    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        getDate() {
            const endTime = moment().format("YYYY-MM-DD");
            const startTime = moment().startOf("month").format("YYYY-MM-DD");
            this.formInline.ReportingTime = [startTime, endTime];
        },
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            if (this.$route.params) {
                this.formInline.eventMessage = this.$route.params.name
            }
            this.getFindFaultData()
        },
        nodeClick(val) {
            this.id = val.label
            this.name = val.value
            this.getFindFaultData()
        },
        getFindFaultData() {
            let param = {
                orgId: this.id,
                selectCarType: this.formInline.selectCarType,
                selectCarValue: this.formInline.selectCarValue,
                terminalId: this.formInline.terminalId,
                eventCode: this.formInline.eventCode,
                eventMessage: this.formInline.eventMessage,
                startTime: this.formInline.ReportingTime[0],
                endTime: this.formInline.ReportingTime[1],
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('FaultManagement/GET_FINDFAULTDATA', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.$refs.page.CommandCurrentPage = 1
            this.currentPage = 1
            this.getFindFaultData()
        },
        onClear() {
            this.formInline = {
                selectCarType: '',
                selectCarValue: '',
                terminalId: '',
                eventCode: '',
            }
            this.getDate()
            this.getFindFaultData()
        },
        getFault() {
            this.$store
                .dispatch("navMenu/GET_SELECTFAULTTYPE", {})
                .then((res) => {
                    if (res) {
                        if (res.data.code == 200) {
                            this.alarmTypeList = res.data.data;
                        }
                    }
                })
                .catch((err) => { });
        },
        downCar() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportFaultManagement?orgId=${this.id}&carId=${this.formInline.carId}&terminalId=${this.formInline.terminalId}&eventCode=${this.formInline.eventCode}&startTime=${this.formInline.ReportingTime[0]}&endTime=${this.formInline.ReportingTime[1]}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportFaultManagement?orgId=${this.id}&carId=${this.formInline.carId}&terminalId=${this.formInline.terminalId}&eventCode=${this.formInline.eventCode}&startTime=${this.formInline.ReportingTime[0]}&endTime=${this.formInline.ReportingTime[1]}`
                    location.href = url
                }
            }
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getFindFaultData();
        },
        handleClick() {

        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}